import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createButton: {
		id: 'issue-create.common.footer.create-button',
		defaultMessage: 'Create',
		description: 'Label for create button in issue create modal',
	},
	createButtonInMiniView: {
		id: 'issue-create.common.footer.create-button-in-mini-view',
		defaultMessage: 'Create',
		description: 'Label for create button in issue create mini view',
	},
	cancelButton: {
		id: 'issue-create.common.footer.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label for cancel button in issue create modal',
	},
	createAnother: {
		id: 'issue-create.common.footer.create-another-fade',
		defaultMessage: 'Create another',
		description: 'Label for create another checkbox in issue create modal',
	},
	copyToNextIssue: {
		id: 'issue-create.common.footer.copy-to-next-issue',
		defaultMessage: 'Copy to next issue',
		description: 'Label for create another toggle in issue create modal',
	},
	copyToNextIssueIssueTermRefresh: {
		id: 'issue-create.common.footer.copy-to-next-issue-issue-term-refresh',
		defaultMessage: 'Copy to next work item',
		description: 'Label for create another toggle in issue create modal',
	},
	issuesCreatedLink: {
		id: 'issue-create.common.footer.issues-created-link',
		defaultMessage: '{issueCount} {issueCount, plural, one {issue} other {issues}} created',
		description: 'Label for link which takes user to GIN with created issues',
	},
	issuesCreatedLinkIssueTermRefresh: {
		id: 'issue-create.common.footer.issues-created-link-issue-term-refresh',
		defaultMessage: '{issueCount} {issueCount, plural, one {work item} other {work items}} created',
		description: 'Label for link which takes user to GIN with created work items',
	},
	createDropdownOptionCreateAnother: {
		id: 'issue-create.common.footer.create-dropdown-option-create-another',
		defaultMessage: 'Create and start another',
		description: 'Label for option in create split button for create another issue',
	},
	createDropdownOptionCopy: {
		id: 'issue-create.common.footer.create-dropdown-option-copy',
		defaultMessage: 'Create and copy',
		description: 'Label for option in create split button for create and copy issue',
	},
	toggleOnTooltip: {
		id: 'issue-create.common.footer.toggle-on-tooltip',
		defaultMessage: 'Toggle off to finish creating issues.',
		description: 'tooltip content when toggle is on',
	},
	toggleOnTooltipIssueTermRefresh: {
		id: 'issue-create.common.footer.toggle-on-tooltip-issue-term-refresh',
		defaultMessage: 'Toggle off to finish',
		description: 'tooltip content when toggle is on',
	},
	toggleOffTooltip: {
		id: 'issue-create.common.footer.toggle-off-tooltip',
		defaultMessage:
			'After selecting {createButton}, immediately start a new issue with these details and fields.',
		description: 'tooltip content when toggle is off',
	},
	toggleOffTooltipIssueTermRefresh: {
		id: 'issue-create.common.footer.toggle-off-tooltip-issue-term-refresh',
		defaultMessage:
			'After selecting {createButton}, immediately start a new work item with these details and fields.',
		description: 'tooltip content when toggle is off',
	},
});
